import type { VariantProps } from 'class-variance-authority';
import { Slot as RadixSlot } from 'radix-ui';
import type * as React from 'react';

import { buttonVariants } from '@/components/ui/variants';
import { cn } from '@/libs/utils';

const Slot = RadixSlot.Slot;

type ButtonProps = {
  asChild?: boolean;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  size?: VariantProps<typeof buttonVariants>['size'];
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({
  ref,
  className,
  variant,
  size,
  asChild = false,
  type = 'button',
  ...props
}: ButtonProps & { ref?: React.RefObject<HTMLButtonElement | null> }) => {
  const baseClassName = cn(buttonVariants({ variant, size }), className);

  if (asChild) {
    // Create props object with explicit types to avoid React type conflicts
    const slotProps = {
      ref,
      className: baseClassName,
      ...props,
    } as React.ComponentProps<typeof Slot>;

    return <Slot {...slotProps} />;
  }

  return (
    <button
      className={baseClassName}
      data-slot="button"
      ref={ref}
      type={type}
      {...props}
    />
  );
};

Button.displayName = 'Button';

export { Button };
